import { createIconSet } from '@expo/vector-icons';
import glyphMap from '~/../assets/fonts/Entypo/unicodesMap.json';
export default createIconSet(glyphMap, 'Entypo', require('~/../assets/fonts/Entypo/Entypo.ttf'));
